import { Flex, Heading } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import RichTextEditor from "react-rte";
import PreviewTextArea from "../../../CustomTextArea/PreviewTextArea";
import "../../../CustomTextArea/rte.css";
import PreviewTemplateChart from "../../../PlanTemplates/PreviewTemplateChart";

const ExternalPreview = ({ measure, key1, key2 }) => {
  const { t } = useTranslation();

  const chartTitle = (measure) => {
    if (measure.collecting_evidence) {
      return t("assessment.externalJuriedAssessment");
    } else {
      return t("assessment.externalAssessment");
    }
  };

  return (
    <Flex direction="column">
      <Flex.Item>
        <Heading level="h3">{chartTitle(measure)}</Heading>
      </Flex.Item>
      {(measure.description || measure.description_text) && (
        <Flex.Item margin="small 0 small large">
          <RichTextEditor
            className="readOnlyClass"
            readOnly
            value={RichTextEditor.createValueFromString(
              measure.description || measure.description_text,
              "html"
            )}
          />
        </Flex.Item>
      )}
      <Flex.Item overflowX="hidden" padding="small 0 small large">
        <PreviewTemplateChart
          bindto={"preview-section-" + key1 + "-measure-" + key2}
          masteryResults={"true"}
          title={t("assessment.masteryAvg")}
        />
      </Flex.Item>
      {measure.collecting_evidence && (
        <>
          <Flex.Item margin="0 0 medium 0" padding="0 0 0 large">
            <PreviewTextArea
              id={`preview-ja-findings-${key1}-${key2}`}
              label={
                <Heading level="h4">{t("juriedAssessment.findings")}</Heading>
              }
              defaultValue={t("results.findingsPreviewHtml")}
            />
          </Flex.Item>
          <Flex.Item padding="0 0 0 large">
            <PreviewTextArea
              id={`preview-ja-recommendations-${key1}-${key2}`}
              label={
                <Heading level="h4">
                  {t("juriedAssessment.recommendations")}
                </Heading>
              }
              defaultValue={t("results.recommendationPreviewHtml")}
            />
          </Flex.Item>
        </>
      )}
    </Flex>
  );
};

export default ExternalPreview;
